
































import {Vue, Component} from 'vue-property-decorator';
import ContractorServiceLogList from "@/components/payroll/business/services/ContractorServiceLogList.vue";
import EmployerServiceLogList from "@/components/payroll/business/services/EmployerServiceLogList.vue";
import InvoiceCreationSlider from "@/components/payroll/business/services/invoice/InvoiceCreationSlider.vue";
import InvoiceList from "@/components/payroll/business/services/invoice/InvoiceList.vue";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {Summary} from "@/components/payroll/business/services/ServiceDTO";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import BillList from "@/components/payroll/business/services/bills/BillList.vue";

type Tabs = "BILLS" | "SERVICE_LOGS"

@Component({
	components: {
		BillList,
		InvoiceList: InvoiceList, InvoiceCreationSlider, EmployerServiceLogList, ContractorServiceLogList}
})
export default class Bills extends Vue {

	private currentTab: Tabs = "BILLS"

	private setTab(tab: Tabs) {
		this.currentTab = tab
	}

	private summary: Summary | null = null

	mounted() {
		this.loadTotal()
	}

	private loadTotal() {
		ServiceInvoiceOrchestrator.getBillSummary(this.$wss.getCurrent.id).then(
			res => {
				this.summary = res.data
			},
			err => processError(err, this)
		)
	}

	get unpaidValue(): string {
		if (this.summary) {
			return "$" + this.summary.unpaid.toLocaleString("en-US", { minimumFractionDigits: 2 })
		} else {
			return "$0.00"
		}
	}

	get paidValue(): string {
		if (this.summary) {
			return "$" + this.summary.paid.toLocaleString("en-US", { minimumFractionDigits: 2 })
		} else {
			return "$0.00"
		}
	}

}
